import React, {Component} from 'react';

class Cog extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M24.04.143c-1.376 0-2.726.124-4.039.347l-.64 6.786a17.2 17.2 0 0 0-3.843 1.585l-5.244-4.332a23.97 23.97 0 0 0-5.721 5.71l4.342 5.244A17.27 17.27 0 0 0 7.3 19.326l-6.774.64a24.018 24.018 0 0 0-.348 4.039c0 1.379.123 2.724.348 4.039l6.774.64a17.272 17.272 0 0 0 1.596 3.843l-4.332 5.244a23.992 23.992 0 0 0 5.7 5.71l5.255-4.342a17.206 17.206 0 0 0 3.843 1.596L20 47.52c1.313.224 2.663.337 4.039.337s2.715-.113 4.028-.337l.64-6.785a17.205 17.205 0 0 0 3.843-1.596l5.255 4.343a24 24 0 0 0 5.7-5.711l-4.332-5.244a17.27 17.27 0 0 0 1.596-3.843l6.774-.64c.225-1.315.348-2.66.348-4.039 0-1.377-.124-2.726-.348-4.039l-6.774-.64a17.272 17.272 0 0 0-1.596-3.843l4.343-5.244a23.983 23.983 0 0 0-5.722-5.71L32.55 8.86a17.197 17.197 0 0 0-3.843-1.585L28.067.49a23.904 23.904 0 0 0-4.028-.347zm0 14.776c5.018 0 9.076 4.069 9.076 9.087s-4.058 9.087-9.076 9.087a9.088 9.088 0 0 1 0-18.174z" fill={this.props.color}/></svg>
        );
    }
}

export default Cog;



// WEBPACK FOOTER //
// ./src/Cog.js